import { RootState } from '../../../app/reducer';
import { TitrationModel } from '../../../models';

export const selectCurrentTrack = ({ currentTrackReducer }: RootState): TitrationModel =>
  currentTrackReducer.currentTrack;
